import { jsx as e, jsxs as c } from "react/jsx-runtime";
import * as o from "@radix-ui/react-dialog";
import { X as p } from "lucide-react";
import { forwardRef as l } from "react";
const S = o.Root, j = o.Trigger, w = o.Portal, z = o.Close, B = o.Root, x = l(function({ className: r, style: a, ...t }, i) {
  return /* @__PURE__ */ e(
    o.Overlay,
    {
      ref: i,
      className: ["ls-dialog-overlay", r].filter(Boolean).join(" "),
      style: {
        position: "fixed",
        inset: 0,
        backgroundColor: "var(--scrim-modal)",
        zIndex: "var(--z-modal)",
        ...a
      },
      ...t
    }
  );
}), u = {
  sm: 480,
  md: 580,
  lg: 680,
  xl: 800
}, k = l(function({ className: r, size: a = "md", style: t, children: i, ...s }, d) {
  return /* @__PURE__ */ c(o.Portal, { children: [
    /* @__PURE__ */ e(x, {}),
    /* @__PURE__ */ e(
      o.Content,
      {
        ref: d,
        className: ["ls-dialog-content", r].filter(Boolean).join(" "),
        style: {
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "calc(100vw - 32px)",
          maxWidth: u[a],
          maxHeight: "88vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "var(--bg-surface)",
          border: "1px solid var(--border-strong)",
          borderRadius: "var(--radius-3xl)",
          boxShadow: "var(--shadow-xl)",
          color: "var(--text-primary)",
          zIndex: "var(--z-modal)",
          overflow: "hidden",
          ...t
        },
        ...s,
        children: i
      }
    )
  ] });
}), T = l(function({ eyebrow: r, title: a, description: t, onClose: i, showClose: s = !0, className: d, style: g, children: f, ...m }, v) {
  return /* @__PURE__ */ c(
    "div",
    {
      ref: v,
      className: ["ls-dialog-header", d].filter(Boolean).join(" "),
      style: {
        padding: "var(--space-6)",
        borderBottom: "1px solid var(--border-subtle)",
        display: "flex",
        alignItems: "flex-start",
        gap: "var(--space-4)",
        flexShrink: 0,
        ...g
      },
      ...m,
      children: [
        /* @__PURE__ */ c("div", { style: { flex: 1, minWidth: 0 }, children: [
          r ? /* @__PURE__ */ e(
            "div",
            {
              style: {
                fontSize: "var(--text-2xs)",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                color: "var(--text-tertiary)",
                fontWeight: "var(--font-weight-semibold)",
                marginBottom: "var(--space-2)"
              },
              children: r
            }
          ) : null,
          a ? /* @__PURE__ */ e(
            o.Title,
            {
              style: {
                margin: 0,
                fontSize: "var(--text-xl)",
                fontWeight: "var(--font-weight-semibold)",
                color: "var(--text-primary)",
                lineHeight: 1.3
              },
              children: a
            }
          ) : null,
          t ? /* @__PURE__ */ e(
            o.Description,
            {
              style: {
                margin: 0,
                marginTop: "var(--space-2)",
                fontSize: "var(--text-sm)",
                color: "var(--text-secondary)"
              },
              children: t
            }
          ) : null,
          f
        ] }),
        s ? /* @__PURE__ */ e(o.Close, { asChild: !0, children: /* @__PURE__ */ e(
          "button",
          {
            type: "button",
            "aria-label": "Close",
            onClick: i,
            style: {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: "var(--radius-md)",
              border: "1px solid transparent",
              background: "transparent",
              color: "var(--text-secondary)",
              cursor: "pointer"
            },
            children: /* @__PURE__ */ e(p, { size: 16, "aria-hidden": "true" })
          }
        ) }) : null
      ]
    }
  );
}), y = {
  padding: "var(--space-6)",
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  fontSize: "var(--text-sm)",
  color: "var(--text-primary)"
}, I = l(
  function({ className: r, style: a, ...t }, i) {
    return /* @__PURE__ */ e(
      "div",
      {
        ref: i,
        className: ["ls-dialog-body", r].filter(Boolean).join(" "),
        style: { ...y, ...a },
        ...t
      }
    );
  }
), h = {
  padding: "var(--space-4) var(--space-6)",
  borderTop: "1px solid var(--border-subtle)",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "var(--space-2)",
  flexShrink: 0,
  background: "var(--bg-surface)"
}, R = l(
  function({ className: r, style: a, ...t }, i) {
    return /* @__PURE__ */ e(
      "div",
      {
        ref: i,
        className: ["ls-dialog-footer", r].filter(Boolean).join(" "),
        style: { ...h, ...a },
        ...t
      }
    );
  }
), H = o.Title, N = o.Description;
export {
  B as D,
  I as a,
  z as b,
  k as c,
  N as d,
  R as e,
  T as f,
  x as g,
  w as h,
  S as i,
  H as j,
  j as k
};
//# sourceMappingURL=Dialog-B4QjcPOf.js.map
